// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '4.1.1'
export const publishDates = {
	major: '2025-09-18T14:39:22.803Z',
	minor: '2025-10-15T12:23:29.168Z',
	patch: '2025-10-15T13:38:40.898Z',
}
